/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acc_Type_SubtitleInputs */

const en_acc_type_subtitle = /** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account type determines how receipts are generated and whether a business badge appears on your storefront.`)
};

const es_acc_type_subtitle = /** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tipo de cuenta determina cómo se generan los recibos y si aparece una insignia de negocio en tu tienda.`)
};

const fr_acc_type_subtitle = /** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre type de compte détermine comment les reçus sont générés et si un badge professionnel apparaît sur votre vitrine.`)
};

const de_acc_type_subtitle = /** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kontotyp bestimmt, wie Quittungen erstellt werden und ob ein Unternehmens-Badge auf deiner Storefront erscheint.`)
};

const id_acc_type_subtitle = /** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis akun Anda menentukan bagaimana tanda terima dibuat dan apakah lencana bisnis muncul di etalase Anda.`)
};

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const ja_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const zh_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const ar_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const it_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const ru_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const pt_acc_type_subtitle = en_acc_type_subtitle;

/** @type {(inputs: Acc_Type_SubtitleInputs) => LocalizedString} */
const ko_acc_type_subtitle = en_acc_type_subtitle;

/**
* | output |
* | --- |
* | "Your account type determines how receipts are generated and whether a business badge appears on your storefront." |
*
* @param {Acc_Type_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acc_type_subtitle = /** @type {((inputs?: Acc_Type_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acc_Type_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acc_type_subtitle(inputs)
	if (locale === "es") return es_acc_type_subtitle(inputs)
	if (locale === "fr") return fr_acc_type_subtitle(inputs)
	if (locale === "de") return de_acc_type_subtitle(inputs)
	if (locale === "ja") return ja_acc_type_subtitle(inputs)
	if (locale === "zh") return zh_acc_type_subtitle(inputs)
	if (locale === "ar") return ar_acc_type_subtitle(inputs)
	if (locale === "id") return id_acc_type_subtitle(inputs)
	if (locale === "it") return it_acc_type_subtitle(inputs)
	if (locale === "ru") return ru_acc_type_subtitle(inputs)
	if (locale === "pt") return pt_acc_type_subtitle(inputs)
	return ko_acc_type_subtitle(inputs)
});